import { Component, OnInit, inject } from '@angular/core';
import {NotificationService} from '../../services';
import {Notification} from '../../models';
import {Observable} from 'rxjs';
import {UpdateNotificationModalComponent} from '../../components';
import {VwuiModalService} from '@bvgo-ict/vwui-angular';
import {take} from 'rxjs/operators';

@Component({
    selector: 'app-page-notifications',
    templateUrl: './page-notifications.component.html',
    styleUrls: ['./page-notifications.component.scss'],
    standalone: false
})
export class PageNotificationsComponent implements OnInit {
    private notificationService = inject(NotificationService);
    private modalService = inject(VwuiModalService);


    public notifications$: Observable<Notification[]>;

    ngOnInit(): void {
        const showUnpublishedVersions = true;
        this.notifications$ = this.notificationService.getNotifications(showUnpublishedVersions);
    }

    public openUpdateNotificationModal(notification: Notification): void {
        const modal = this.modalService.open(UpdateNotificationModalComponent,
            {
                closeOnBackdropClick: false,
                modalClass: 'medium-modal',
                data: notification.getData()
            }
        );

        modal.afterClosed
            .pipe(take(1))
            .subscribe(() => {
                const showUnpublishedVersions = true;
                this.notificationService.updateNotifications(showUnpublishedVersions);
            });
    }

}
